import { createSlice } from '@reduxjs/toolkit';
import { SLICE_NAME } from 'constants/common';

const initialState = {
    organizationId: '',
    organizationName: '',
    reloadUnit: false,
    isAddUnit: false
};

export const organizationTreeSlice = createSlice({
    name: SLICE_NAME.ORGANIZATION_TREE,
    initialState,
    reducers: {
        setOrganizationId: (state, action) => {
            state.organizationId = action.payload;
        },
        setOrganizationName: (state, action) => {
            state.organizationName = action.payload;
        },
        setReloadUnit: (state, action) => {
            state.reloadUnit = !state.reloadUnit;
        },
        setIsAddUnit: (state, action) => {
            state.isAddUnit = action.payload;
        }
    },
});

export const {
    setOrganizationId,
    setOrganizationName,
    setReloadUnit,
    setIsAddUnit
} = organizationTreeSlice.actions;
export default organizationTreeSlice.reducer;
